import React from 'react';

import { Link } from '@mui/material';

import CopyableField from '~/components/Common/CopyableField';
import { promoCodePath } from '~/components/Promo/promoUrls';

type PromoCodeNameProps = {
  codeName: string;
};

function PromoCodeName({ codeName }: PromoCodeNameProps) {
  return (
    <CopyableField
      value={codeName}
      label={
        <Link noWrap href={promoCodePath(codeName)} title={codeName}>
          {codeName}
        </Link>
      }
    />
  );
}

export { PromoCodeName };
